import client from '../client';
import endpoints from '../endpoints';

/**
 * 리뷰 — 서비스 + 관리자 API
 * API_DOCS: 11. 리뷰 / 25. 관리자 - 리뷰
 */

/* ── 서비스 (유저용) ── */

export const getReviews = async (params = {}) => {
  const res = await client.get(endpoints.reviews.list, { params });
  return res.data;
};

export const createReview = async (data) => {
  const res = await client.post(endpoints.reviews.create, data);
  return res.data;
};

export const updateReview = async (id, data) => {
  const res = await client.put(endpoints.reviews.detail(id), data);
  return res.data;
};

export const deleteReview = async (id) => {
  const res = await client.delete(endpoints.reviews.detail(id));
  return res.data;
};

/** GET /api/reviews/stats?service_type=airport */
export const getReviewStats = async (params = {}) => {
  const res = await client.get(endpoints.reviews.stats, { params });
  return res.data;
};

/* ── 관리자 ── */

export const getAdminReviews = async (params = {}) => {
  const res = await client.get(endpoints.admin.reviews.list, { params });
  return res.data;
};

export const getAdminReviewById = async (id) => {
  const res = await client.get(endpoints.admin.reviews.detail(id));
  return res.data;
};

export const updateAdminReviewStatus = async (id, status) => {
  const res = await client.put(endpoints.admin.reviews.status(id), { status });
  return res.data;
};
